import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { HrmsService } from '../hrms.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  openMenu: string | null = 'master';
  isMasterOpen = false;

  isCollapsed: boolean = false;
  activeView: any = '';
  savedView: any;
  roleDetails: any;

  showMainHrms = false;
  showSubjectDetails = false;
  showDeptDesign = false;
  showCostcenter = false;
  showEmployeeExits = false;


  MainHrmslabel: any;
  subjectDetails: any;
  deptDesign: any;
  costCenter: any;
  employeeExit:any;

  constructor(private Service: HrmsService, private router: Router, private spinner: NgxSpinnerService,) {

    const storedView = localStorage.getItem('routeNames') || '';
    this.savedView = storedView;
    this.Service.setView(this.savedView);
    this.Service.view$.subscribe(view => {
      this.activeView = view;
    });

    this.Service.collapsed$.subscribe(data => {
      this.isCollapsed = data;
    });
  }
  ngOnInit(): void {
    this.rolemanagement();
  }

  rolemanagement() {
    localStorage.removeItem('routeNames');
    this.spinner.show();
    const payrollId = localStorage.getItem('userId');
    // const payrollId = 'hyd110010728'
    this.Service.getRolemanagement(payrollId).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.roleDetails = res;
        console.log('this.roleDetails', this.roleDetails);

        let hasAnyGrievanceAccess = false;
        for (const group of this.roleDetails.userAppForms) {
          if (group.formGroup === 'REPORTS') {
            this.Service.setReportsSelected(true);
            this.MainHrmslabel = group.formGroupLabel;
            this.showMainHrms = true;
          }
          for (const form of group.appForms) {
            switch (form.appFormName.trim()) {
              case 'SUBJECT_DETAILS':
                this.subjectDetails = form.appFormLabel;
                this.showSubjectDetails = true;
                hasAnyGrievanceAccess = true;
                break;

              case 'DEPT_DESIG_DETAILS':
                this.deptDesign = form.appFormLabel;
                this.showDeptDesign = true;
                hasAnyGrievanceAccess = true;
                break;

              case 'COST_CENTER_DETAILS':
                this.costCenter = form.appFormLabel;
                this.showCostcenter = true;
                hasAnyGrievanceAccess = true;
                break;
              case 'EMPLOYEE_EXIT_DETAILS':
                this.employeeExit = form.appFormLabel;
                this.showEmployeeExits = true;
                hasAnyGrievanceAccess = true;
                break;
              default:
                console.warn('Unhandled form:', form.appFormName);
                break;
            }
          }
        }

        // Set localStorage based on grievance access
        const viewToSet = hasAnyGrievanceAccess ? 'hrmssubject' : 'hrmssubject';
        localStorage.setItem('routeNames', viewToSet);
        this.savedView = viewToSet;
        this.Service.setView(this.savedView);
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
      }
    });
  }

  showtosubjectDetails() {
    this.Service.setView('hrmssubject');
  }

  showtoDeptdesign() {
    this.Service.setView('Deptdesign');
  }
  showtocostcenter() {
    this.Service.setView('costcenter');
  }
  showtoemployeeexit() {
    this.Service.setView('employeeexit');
  }

  toggleCollapse() {
    // this.Service.toggleCollapse();
  }

  refreshComponent() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/HrmsReport']);
    });
  }

  toggleMasterMenu() {
    this.isMasterOpen = !this.isMasterOpen;
  }

  toggleSubMenu(menu: string): void {
    this.openMenu = this.openMenu === menu ? null : menu;
  }

  openSidebar() {
    this.Service.openSidebar();
  }

}